import XAPPButton from "app/Core/Components/Button/XAPPButton";
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { save } from '../Store/Actions/AgendamentoEdicaoActions';

function DisponibilizarButton({ callback, data, xappRouteParams, icon, tooltip, type, className, iconProps, key }) {

    const dispatch = useDispatch();
    useEffect(() => {

    }, []);

    return (
        <React.Fragment>
            <XAPPButton
                variant="contained"
                color="primary"
                tooltip={tooltip}
                type={type}
                className={className}
                iconProps={iconProps}
                icon={icon}
                key={key}
                onClick={() => {
                    dispatch(save({ ...data, "status": { "id": 2, "iniciarprocesso": true }, idtarefaprocesso: null }, xappRouteParams, "ALTERARSTATUS", callback))
                }}
            />
        </React.Fragment>
    );
}

export default DisponibilizarButton;
